import { Model } from "./Model";

export class Phone extends Model {
  static props = {
    id: { type: Number },
    number: { type: String },
    type: { type: String }
  };

  constructor(parameters) {
    super(Phone.props, parameters);
  }
}
